import { useAppState } from '../appState'

const useAdmin = () => {
  let [appState] = useAppState()
  let isAdmin = false
  let userRole = appState.auth?.idToken?.payload['custom:user_role']
  if (userRole === 'admin' || userRole === 'super-admin') isAdmin = true

  return [isAdmin, userRole]
}

export default useAdmin
